import { memo, useEffect } from "react";

// -----------------------------------------------------------------------------

export const RemoveLoader = memo(function RemoveLoader() {
  useEffect(() => window.tkRemoveLoader(), []);

  //
  return null;
});
